import { Box, Fade } from '@mui/material';

interface QrIconOverlayProps {
  iconName: string | null;
  visible: boolean;
}

export function QrIconOverlay({ iconName, visible }: QrIconOverlayProps) {
  return (
    <Fade in={visible && iconName !== null} timeout={300}>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: 'rgba(255, 255, 255, 0.92)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 3,
          }}
        >
          {iconName && (
            <Box
              component="img"
              src={`/qr-icons/${iconName}.svg`}
              alt=""
              sx={{ width: 36, height: 36, display: 'block' }}
            />
          )}
        </Box>
      </Box>
    </Fade>
  );
}
